import { observer } from 'mobx-react';
import { ImportedParticipantsResource, ViewReportAction } from '../../Store/Types';
import ParticipantRow from './Row';

interface Props {
  importedParticipantsResource: ImportedParticipantsResource;
  viewReport: ViewReportAction;
}

function BodyContent({ importedParticipantsResource, viewReport }: Props) {
  const {
    successfulParticipants,
    failedParticipants,
    formattingIssue,
    participantsOfDifferentOrg,
    participantsOfSameOrg,
  } = importedParticipantsResource.payload;
  switch (viewReport) {
    case 'full-view':
      return (
        <>
          {[
            ...successfulParticipants,
            ...failedParticipants,
            ...participantsOfDifferentOrg,
            ...participantsOfSameOrg,
            ...formattingIssue,
          ].map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
    case 'already-exist-in-diff-org':
      return (
        <>
          {participantsOfDifferentOrg.map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
    case 'already-exist-in-same-org':
      return (
        <>
          {participantsOfSameOrg.map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
    case 'formatting-issue':
      return (
        <>
          {formattingIssue.map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
    case 'success-view':
      return (
        <>
          {successfulParticipants.map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
    case 'import-failed':
      return (
        <>
          {failedParticipants.map((participant) => (
            <ParticipantRow participant={participant} key={participant.email} />
          ))}
        </>
      );
  }
}

export default observer(BodyContent);
